module.exports = __webpack_public_path__ + "static/img/htmb-min.e5d4ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/htmb-min.jpg
// module id = iBAe
// module chunks = 1